import { z, isoZ } from 'my-zod'

import { gearUsageFragment } from '../../utilities/gear-usage'

export const WaiverOriginationEnum = z.enum(['CustomerWebWaiver', 'OperatorAppWaiver'])

export type WaiverOriginationEnum = z.infer<typeof WaiverOriginationEnum>

export const customerWaiversModel = z.object({
  id: z.string().uuid(),
  customerId: z.string().max(36).nullish(),
  productLineForRental: z.string(),
  operatorCustomProductForRental: z.string().nullable(),
  proposedRideDate: isoZ.date().nullable(),
  firstTimeRider: z.boolean(),
  driverFirstName: z.string().nullable(),
  driverLastName: z.string().nullable(),
  driverPostalCode: z.string().nullable(),
  driverDOB: isoZ.instant().nullable(),
  driverEmail: z.string().nullable(),
  driverPrimaryPhone: z.string().nullable(),
  driverLicenseState: z.string().nullable(),
  driverLicenseNumber: z.string().nullable(),
  driverAddressLine1: z.string().nullable(),
  driverAddressLine2: z.string().nullable(),
  driverAddressCity: z.string().nullable(),
  driverAddressState: z.string().nullable(),
  driverAddressCountry: z.string().nullable(),
  driverHasMotorcycleLicense: z.boolean().nullable(),
  driverInsuranceProvider: z.string().nullable(),
  driverInsurancePolicyNumber: z.string().nullable(),
  driverAdditionalEmailOptIn: z.boolean().nullable(),
  waiverFormSnapshotUrl: z.string().nullable(),
  waiverAgreementVersion: z.string().nullable(),
  waiverAgreementPdfUrl: z.string().nullable(),
  waiverQuestions: z.string().nullable().array().nullable(),
  operatorId: z.number(),
  damageWaiverPlanId: z.number().nullable(),
  vehicleModel: z.string().nullable(),
  rentalLengthHours: z.number().nullable(),
  gearUsage: gearUsageFragment.array().nullable(),
  waiverOrigination: WaiverOriginationEnum.nullable(),
  customerOrderId: z.string().uuid().nullable(),
  rideGroupId: z.string().uuid().nullish(),
  createdDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable(),
  serverLastModifiedDate: isoZ.instant().nullable(),
  lastDeviceId: z.string().nullable(),
  hasVehicleUseHistory: z.boolean().nullable(),
  isHidden: z.boolean().nullable(),

  // legacy riders/participant interface
  additionalParticipantFullName1: z.string().nullish(),
  additionalParticipantFullName2: z.string().nullish(),
  additionalParticipantFullName3: z.string().nullish(),
  additionalParticipantFullName4: z.string().nullish(),
  additionalParticipantFullName5: z.string().nullish(),

  isParticipant1Minor: z.boolean().nullish(),
  isParticipant2Minor: z.boolean().nullish(),
  isParticipant3Minor: z.boolean().nullish(),
  isParticipant4Minor: z.boolean().nullish(),
  isParticipant5Minor: z.boolean().nullish()
})

export type customerWaiversModel = z.infer<typeof customerWaiversModel>
